export const countryFlags: Map<string, string> = new Map([
    ['BE', '🇧🇪'],
    ['BG', '🇧🇬'],
    ['DK', '🇩🇰'],
    ['DE', '🇩🇪'],
    ['FI', '🇫🇮'],
    ['FR', '🇫🇷'],
    ['GR', '🇬🇷'],
    ['GB', '🇬🇧'],
    ['IT', '🇮🇹'],
    ['HR', '🇭🇷'],
    ['LL', '🇱🇻'],
    ['LU', '🇱🇺'],
    ['NL', '🇳🇱'],
    ['NO', '🇳🇴'],
    ['AT', '🇦🇹'],
    ['PL', '🇵🇱'],
    ['PT', '🇵🇹'],
    ['RO', '🇷🇴'],
    ['SE', '🇸🇪'],
    ['CH', '🇨🇭'],
    ['SK', '🇸🇰'],
    ['SI', '🇸🇮'],
    ['ES', '🇪🇸'],
    ['CZ', '🇨🇿'],
    ['TR', '🇹🇷'],
    ['HU', '🇭🇺'],
    ['US', '🇺🇸'],
]);
